<template>
  <div class="big">
    <div class="page_title">分账设置</div>
    <div style="padding: 20px; border-radius: 5px">
      <div
        class="container"
        style="padding: 20px;"
      >
        <el-tabs v-model="activeName">
          <el-tab-pane
            label="处方订单"
            name="1"
          ></el-tab-pane>
          <el-tab-pane
            label="问诊费"
            name="2"
          ></el-tab-pane>
          <el-tab-pane
            label="商品订单"
            name="3"
          ></el-tab-pane>
          <el-tab-pane
            label="体检订单"
            name="4"
          ></el-tab-pane>
          <el-tab-pane
            label="会员购买"
            name="5"
          ></el-tab-pane>
        </el-tabs>
        <component
          :is="currentComponent"
          :configList="configList"
        />
      </div>
    </div>
  </div>
</template>
<script>
import system from '../../../api/system';
import RecipeOrder from './RecipeOrder.vue';
import AskCost from './AskCost.vue';
import GoodsOrder from './GoodsOrder.vue';
import MedicalOrder from './MedicalOrder.vue';
import VipBuy from './VipBuy.vue';
export default {
  data() {
    return {
      activeName: '1',
      configList: []
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array || [];
    },
    currentComponent() {
      switch (this.activeName) {
        case '1':
          return RecipeOrder;
        case '2':
          return AskCost;
        case '3':
          return GoodsOrder;
        case '4':
          return MedicalOrder;
        case '5':
          return VipBuy;
        default:
          return RecipeOrder;
      }
    }
  },
  created() {
    this.getConfig();
  },
  methods: {
    getConfig() {
      system.getChinaumsHospital().then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.configList = data.list;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
</style>
